(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["soko-lovable-footer"]) return;
  try {
    
  const sokoFooterMenuQuery = window.matchMedia('(max-width: 749px)');

  const syncSokoFooterMenus = (query) => {
    document.querySelectorAll('.soko-lovable-footer__column').forEach((menu) => {
      menu.open = !query.matches;
    });
  };

  syncSokoFooterMenus(sokoFooterMenuQuery);
  sokoFooterMenuQuery.addEventListener('change', syncSokoFooterMenus);

  } catch(e) { console.error(e); }
})();
})();
